import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { T } from 'react-translator-component';

const color = "#4A154B";

const MainContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 16px;
`

const StepContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 45px;
  position: relative;
  :before {
    content: '';
    position: absolute;
    background: #f3e7f3;
    height: 4px;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }
  :after {
    content: '';
    position: absolute;
    background: ${color};
    height: 4px;
    width: ${({ width }) => width};
    top: 50%;
    transition: 0.4s ease;
    transform: translateY(-50%);
    left: 0;
  }
`

const StepWrapper = styled.div`
  position: relative;
  z-index: 1;
`

const StepStyle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 3px solid ${({ step }) =>
    step === 'completed' ? `${color}` : '#F3E7F3'};
  transition: 0.4s ease;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StepCount = styled.span`
  font-size: 19px;
  color: ${({ current }) => current ? `${color}` : '#f3e7f3'};
  @media (max-width: 600px) {
    font-size: 16px;
  }
`

const StepsLabelContainer = styled.div`
  position: absolute;
  top: 55px;
  left: 50%;
  transform: translate(-50%, -50%);
`

const StepLabel = styled.span`
  font-size: 1rem;
  color: ${color};
  @media (max-width: 600px) {
    font-size: 0.75rem;
  }
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 -15px;
  margin-top: 100px;
`

const ButtonStyle = styled.button`
  border-radius: 4px;
  border: 0;
  background: ${color};
  color: #ffffff;
  cursor: pointer;
  padding: 8px;
  width: 90px;
  :active {
    transform: scale(0.98);
  }
  :disabled {
    background: #f3e7f3;
    color: #000000;
    cursor: not-allowed;
  }
`

const CheckMark = styled.div`
  font-family: sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: ${color};
  -ms-transform: scaleX(-1) rotate(-46deg); /* IE 9 */
  -webkit-transform: scaleX(-1) rotate(-46deg); /* Chrome, Safari, Opera */
  transform: scaleX(-1) rotate(-46deg);
`

const ProgressSteps = ({ steps, activeStep }) => {
  //   const [activeStep, setActiveStep] = useState(1)

  //   const nextStep = () => {
  //     setActiveStep(activeStep + 1)
  //   }

  //   const prevStep = () => {
  //     setActiveStep(activeStep - 1)
  //   }


  //   useEffect(() => {
  //     if (onChangeStep) {
  //         onChangeStep.call(this, activeStep);
  //     }
  //   }, [ activeStep ]);

  const totalSteps = steps.length

  const width = `${(100 / (totalSteps - 1)) * (activeStep - 1)}%`

  return (
    <MainContainer className='progress-main-container'>
      <StepContainer width={width} className='progress-step-container'>
        {steps.map(({ step, label }) => (
          <StepWrapper key={step} className='progress-step-wrapper'>
            <StepStyle step={activeStep >= step ? 'completed' : 'incomplete'} className='progress-step-style'>
              {activeStep > step ? (
                <CheckMark>L</CheckMark>
              ) : (
                <StepCount current={activeStep === step}>{step}</StepCount>
              )}
            </StepStyle>
            <StepsLabelContainer className='step-label text-truncate-1-line' style={{ paddingLeft: "4px", paddingRight: "4px", maxWidth: "85px" }}>
              <StepLabel className='progress-step-label text-nowrap' key={step}>{label}</StepLabel>
            </StepsLabelContainer>
          </StepWrapper>
        ))}
      </StepContainer>
      {/* <ButtonsContainer>
        <ButtonStyle onClick={prevStep} disabled={activeStep === 1}>
          Previous
        </ButtonStyle>
        <ButtonStyle onClick={nextStep} disabled={activeStep === totalSteps}>
          Next
        </ButtonStyle>
      </ButtonsContainer> */}
    </MainContainer>
  )
}

export default ProgressSteps